export default {
    ServerUrl: 'https://harvest.grandiz.com',
    ApiUrl: 'https://harvest.grandiz.com/api/v1',
    client_id: 'cu_rsZPK-qWvCY_ixEZ2-YMX',
    redirect_uri: 'https://harvest.grandiz.com/',
}


// WEBPACK FOOTER //
// ./src/config/prod.js